import { render, staticRenderFns } from "./main_report.vue?vue&type=template&id=19a9c7cb&scoped=true&"
import script from "./main_report.vue?vue&type=script&lang=js&"
export * from "./main_report.vue?vue&type=script&lang=js&"
import style0 from "./main_report.vue?vue&type=style&index=0&id=19a9c7cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a9c7cb",
  null
  
)

export default component.exports